import React from 'react'
import useIsMobile from './useIsMobile'

const withIsMobile = (Component) => (props) => {
  const isMobile = useIsMobile()

  return <Component {...props} isMobile={isMobile} />
}

export default withIsMobile
